import puzzlesAPI from '../../API/puzzlesConfig'
import { PuzzleStatus } from '../PuzzlesView/functions/puzzlesApi'
import { QuestPuzzle } from './types'

// Retry configuration
const RETRY_CONFIG = {
    maxRetries: 3,
    retryDelay: 1000, // 1 second
    backoffMultiplier: 2, // exponential backoff
}

/**
 * Retry wrapper for async functions with exponential backoff
 */
const withRetry = async <T>(
    fn: () => Promise<T>,
    retries = RETRY_CONFIG.maxRetries,
    delay = RETRY_CONFIG.retryDelay,
): Promise<T | undefined> => {
    try {
        return await fn()
    } catch (error) {
        if (retries === 0) {
            console.error('[RETRY] Max retries reached:', error)
            return undefined
        }

        console.warn(`[RETRY] Attempt failed, retrying in ${delay}ms... (${retries} retries left)`)

        await new Promise((resolve) => setTimeout(resolve, delay))

        return withRetry(fn, retries - 1, delay * RETRY_CONFIG.backoffMultiplier)
    }
}

export const getPuzzleQuest = async (): Promise<QuestPuzzle | undefined> => {
    return withRetry(async () => {
        console.log('[] Fetching next puzzle quest...', new Date())
        const response = await puzzlesAPI.get('/api/quest/puzzles/next')
        return response.data
    })
}

export interface IResolvePuzzleQuest {
    puzzleId: string
    status: PuzzleStatus
    usedHints: number
}

export const resolvePuzzle = async (data: IResolvePuzzleQuest): Promise<QuestPuzzle | undefined> => {
    return withRetry(async () => {
        const response = await puzzlesAPI.put(`/api/quest/puzzles/${data.puzzleId}/resolve`, {
            status: data.status,
            usedHints: data.usedHints,
        })
        return response.data
    })
}
